<template>
	<div class="instructions stats">

		<ul class="uk-flex-center uk-margin-bottom" uk-tab>
			<li><a href="#">Статистика по тренажерам</a></li>
			<li><a href="#">Домашние задания</a></li>
      <li v-if="!student.is_outside"><a href="#">Дженкоины</a></li>
		</ul>

		<ul class="uk-switcher uk-margin">
			<!--Тренажеры-->
			<li>
				<div class="stats__wrap">
					<date-picker
            :range="true"
            :format="'DD-MM-YYYY'"
            v-model="dates"
            valueType="format"
            :placeholder="'Диапазон дат'"
            @input="getStatData"
          ></date-picker>
				</div>

				<div class="stats__body">
					<TabStats v-if="statData" :statData="statData" />
					<h4 v-if="active && !statData" class="uk-margin-top">Нет данных за выбранный период. Попробуйте изменить запрос</h4>
				</div>

			</li>

			<!--ДОМАШНЕЕ ЗАДАНИЕ-->
			<li>
				<HwStats :student_id="student.id" />
			</li>

      <!-- КОИНЫ -->
      <li>
        <CoinStats :student_id="student.id" />
      </li>
		</ul>
	</div>
</template>

<script>
  import TabStats from './../stats/TabStats'
  import HwStats from "./HwStats";
  import moment from 'moment'
  import CoinStats from "./CoinStats";

  export default {
    name: "stat_body",
    inject: ['http'],
    props: ['student'],
    data() {
      return {
        dates: '',
        statData: null,
        active: false
      }
    },
    components: { TabStats, HwStats, CoinStats },
    methods: {
      getAutoData() {
        this.dates = [
          moment().subtract(7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')
        ]
        this.getStatData();
      },
      async getStatData() {
        if (!this.dates.includes(null)) {
          let data = {
            dates: this.dates,
            student_id: this.student.id
          };
          this.active = false;
          this.statData = await this.http.post('onGetStats', data).then(res => res.data)
          this.active = true;
          console.log(this.statData)
        } else {
          swal('', 'Выберите дату', 'warning')
        }
      }
    },
    mounted() {
      this.getAutoData();
    }
  }
</script>
